
<!-- INDICE -->
<!-- <app-table-of-content [sections]="getTableOfContentOps()" [previewItems]="3" (selection)="scrollIntoView($event)"></app-table-of-content> -->

<!-- INTRO CARD -->
<app-intro-card [data]="introSection" #intro></app-intro-card>

<!-- BANNER Y GUIA ELEGIR UNIVERSIDAD DETALLES -->
<span #primerospasos></span>
<!-- <app-card-with-content *ngIf="isProductIdActive(17) || isOrderPaid()" [cardInfo]="cardProduct17"></app-card-with-content>
<app-card-cta *ngIf="!isProductIdActive(17) && !isOrderPaid()" [status]="getOrderStatus()" [cardInfo]="cardProduct17" (callToAction)="buyProduct($event)"></app-card-cta> -->

<!-- QUE ES EL VISADO / ESTUDIAR EN ESPAÑA -->
<span #visado></span>
<app-app-section [sectionInfo]="sectionQueEsVisado"></app-app-section>

<!-- --------------------------------GUIA AVANZADA PARA OBTENER VISADO -->
<!-- Banner -->
<app-card-article *ngIf="false && !isProductIdActive(1)" [sectionInfo]="guiaAvanzadaVisado" (callToAction)="buyProduct($event)"></app-card-article>

<!-- Pipeline -->
<app-visa-pipeline *ngIf="false"></app-visa-pipeline><!-- *ngIf="isProductIdActive(1)" -->

<!-- Banner LISTA DE REQUISITOS PARA OBTENER VISADO-->
<!-- <app-card-cta *ngIf="!isProductIdActive(54)" [cardInfo]="cardProduct1" (callToAction)="buyProduct($event)"></app-card-cta> -->

<!-- Lista de requisitos -->
<span #requisitos></span>
<app-app-section-accordion [sectionInfo]="sectionRequisitosVisado" *ngIf="isProductIdActive(54)"></app-app-section-accordion>

<!-- Link a requisitos de la embajada -->
<app-section-post-list-img [sectionInfo]="requisitosEmbajada" *ngIf="isProductIdActive(54)"></app-section-post-list-img>

<!-- NOTAS IMPORTANTES -->
<span #notas></span>
<app-section-post-list [sectionInfo]="notasImportantes"></app-section-post-list>

<!-- FAQS -->
<!-- <span #faqs></span>
<app-section-multi-accordion [sectionInfo]="faqSection"></app-section-multi-accordion> -->